export default "__VITE_ASSET__CbpUxnXK__"